/**
 * A component for inserting fixed space between components.  Must be a child
 * a flexbox container.
 *
 * TODO(charlie): Build support for responsive layouts into Strut (i.e.,
 * clients should be able to specify different sizes for different screen
 * sizes).
 */

import * as React from "react";

/**
 * @deprecated Please use Strut from @khanacademy/wonder-blocks-layout instead.
 */
class DeprecatedStrut extends React.Component<{
    size: number;
}> {
    render(): React.ReactNode {
        return <div style={flexBasis(this.props.size)} />;
    }
}

const flexBasis = (size: number) => {
    return {
        MsFlexBasis: size,
        MsFlexPreferredSize: size,
        WebkitFlexBasis: size,
        flexBasis: size,
        flexShrink: 0,
    };
};

export default DeprecatedStrut;
